import React, { useState } from 'react'
import { IconCheck, IconX } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'
import { EditButton } from '@/components/buttons/EditButton'
import { MediaPlayerButton } from '@/components/media/components/MediaPlayerButton'

export const EditPlaylistCallAlias = ({
  call,
  handleEditAlias,
  generateCallExplorerLink,
  pauseAudio,
  callType = 'call',
}) => {
  const [editing, setEditing] = useState(false)
  const [tempAlias, setTempAlias] = useState('')
  const id = callType === 'call' ? call.call_id : call.message_id
  if (editing) {
    return (
      <form
        onSubmit={(event) => {
          event.preventDefault()

          setEditing(false)
          handleEditAlias(tempAlias, call)
        }}
        className="flex-align-center small-gap no-wrap"
        data-testid="edit-playlist-call-alias-form"
      >
        <TextInput
          small
          data-testid="alias-input"
          type="text"
          value={tempAlias}
          maxLength={100}
          onChange={(event) => setTempAlias(event.target.value)}
          placeholder="Enter alias..."
          autoFocus
        />
        <Button
          small
          square
          onClick={() => {
            setTempAlias('')
            setEditing(false)
          }}
        >
          <IconX />
        </Button>
        <Button small data-testid="alias-submit-button" square brand type="submit">
          <IconCheck />
        </Button>
      </form>
    )
  }

  return (
    <div className="flex-align-center medium-gap no-wrap hidden-button-outer">
      {callType === 'call' && <MediaPlayerButton call={call} />}
      <a
        data-testid="playlist-call-link"
        href={generateCallExplorerLink(id)}
        onClick={pauseAudio}
        className="table-link"
      >
        {call.alias || id}
      </a>
      <EditButton className="hidden-button" onEdit={() => setEditing(true)} />
    </div>
  )
}
